let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3UHH0")).then(() => parcelRequire('d0aTg'));